const KOSOVO_TZ = 'Europe/Belgrade'

/**
 * Formats a UTC date for display in Kosovo local time (Europe/Belgrade).
 * Handles DST automatically (CET/CEST).
 * Use for interview dates and any datetime stored as UTC that should display in Kosovo.
 *
 * @param {string|Date} date - UTC date string (e.g. ISO) or Date object
 * @returns {string} Formatted date in Kosovo local time (e.g. "November 25, 2025 10:50 AM")
 */
export const formatKosovoDate = (date) => {
  const d = typeof date === 'string' ? new Date(date) : date
  if (!d || isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat('en-US', {
    timeZone: KOSOVO_TZ,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(d)
}
